import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { IReplicatorScheduleDowntime } from "@coso-replicator/core";
import { Observable } from "rxjs";

@Injectable({
  providedIn: "root"
})
export class ScheduleDowntimeService {
  constructor(private http: HttpClient) {}

  getScheduleDownTimeAsync(): Observable<IReplicatorScheduleDowntime> {
    return this.http.get<IReplicatorScheduleDowntime>(`/api/scheduled-downtime/downtime`);
  }
}
